module.exports = __webpack_public_path__ + "media/images/games/k2gender/nurse-9a6bf04ac5390b9e981740b492846d9e.png";